/** Stripe Payment Link (test); change for production when you rotate the link. */
export const STRIPE_SUBSCRIBE_PAYMENT_LINK =
  "https://buy.stripe.com/8x214p89d9ok7zm9Ux7ss00";

/** True if Mongo user has a Stripe subscription id stored (post-checkout). */
export function hasMongoStripeSubscriptionId(user) {
  const id = user?.subscriptionId;
  return Boolean(id != null && String(id).trim());
}

/**
 * @returns {string|null} Payment Link URL with query params, or null if uid missing / URL invalid
 */
export function getStripeSubscribePaymentLinkUrl(firebaseUid, email) {
  const base = STRIPE_SUBSCRIBE_PAYMENT_LINK.trim();
  if (!base || !firebaseUid?.trim()) {
    return null;
  }
  try {
    const url = new URL(base);
    url.searchParams.set("client_reference_id", firebaseUid.trim());
    if (email?.trim()) {
      url.searchParams.set("prefilled_email", email.trim());
    }
    return url.toString();
  } catch {
    return null;
  }
}
